<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-grid full-width>
      <cv-row>
        <cv-column :sm="4" :md="5" :lg="13">
          <cv-combo-box label=""
                        title="Cliente" :auto-filter="true"
                        value="Azienda Agricola Mario Rossi s.r.l"
                        :options="clienti"></cv-combo-box>
        </cv-column>
        <cv-column :sm="4" :md="3" :lg="3">
          <cv-text-input label="Anno" value="2021" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-data-table :columns="colonne"
                         :data="righe"
                         helper-text="Le prime due colonne sono relative al cliente, le seconde sono dati generali"
                         title="Riepilogo" />
        </cv-column>
      </cv-row>
    </cv-grid>
  </cv-content>
</template>

<script>

export default {
  name: "RiepilogoFattPerCliente",
  data: function() {
    return {

      clienti: [
        {
          value: "1",
          label: "Azienda Agricola Mario Rossi s.r.l",
          name: "1"
        },
        {
          value: "2",
          label: "Paolo Verdi s.r.l",
          name: "2"
        }
      ],
      colonne: [
          " ",
          "Imponibile (Cliente)",
          "IVA (Cliente)",
          "Imponibile (Generale)",
          "IVA (Generale)"
      ],
      righe: [
        [
          "Lavorazioni Eseguite",
          "€ 0,00",
          "€ 0,00",
          "€ 0,00",
          "€ 0,00",
        ],
        [
          "Totale Fatturato",
          "€ 0,00",
          "€ 0,00",
          "€ 0,00",
          "€ 0,00",
        ],
        [
          "Da Incassare",
          "€ 0,00",
          "€ 0,00",
          "€ 0,00",
          "€ 0,00",
        ],
        [
          "Già Incassati",
          "€ 0,00",
          "€ 0,00",
          "€ 0,00",
          "€ 0,00",
        ],
      ]
    }
  }
}
</script>

<style scoped>

</style>